import React from 'react';
import { CheckCircle, AlertCircle, XCircle, ArrowRight, Plus, ScanBarcode } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const STATUS_ICONS = {
  found: <CheckCircle className="w-5 h-5 text-emerald-600" />,
  created: <Plus className="w-5 h-5 text-purple-600" />,
  transfer: <ArrowRight className="w-5 h-5 text-blue-600" />,
  extra: <AlertCircle className="w-5 h-5 text-amber-600" />,
  error: <XCircle className="w-5 h-5 text-rose-600" />,
};

const STATUS_CLASSES = {
  found: 'bg-emerald-100 text-emerald-800',
  created: 'bg-purple-100 text-purple-800',
  transfer: 'bg-blue-100 text-blue-800',
  extra: 'bg-amber-100 text-amber-800',
  error: 'bg-rose-100 text-rose-800',
};

const ScanHistoryPanel = ({ scanHistory, onClear }) => {
  if (scanHistory.length === 0) return null;

  return (
    <Card className="mt-6 border-2 border-blue-200 bg-blue-50/30">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center justify-between text-lg">
          <div className="flex items-center gap-2">
            <div className="relative">
              <ScanBarcode className="w-5 h-5 text-blue-600" />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            </div>
            <span>Scans en cours</span>
            <Badge variant="secondary" className="ml-2">{scanHistory.length}</Badge>
          </div>
          <Button variant="ghost" size="sm" onClick={onClear} className="text-slate-500 hover:text-slate-700">
            Effacer
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {scanHistory.map((entry, index) => (
            <div
              key={entry.id}
              className={`flex items-center gap-3 p-3 rounded-lg text-sm transition-all ${
                index === 0 ? 'ring-2 ring-blue-300 shadow-sm' : ''
              } ${STATUS_CLASSES[entry.status] || 'bg-rose-100 text-rose-800'}`}
            >
              <div className="flex-shrink-0">
                {STATUS_ICONS[entry.status] || <XCircle className="w-5 h-5 text-rose-600" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono font-bold">{entry.code}</span>
                  {entry.furniture && (
                    <span className="text-xs opacity-75">
                      {entry.furniture.marque} {entry.furniture.modele}
                    </span>
                  )}
                </div>
                <div className="text-xs opacity-75 mt-0.5">
                  {entry.message}
                  {entry.transferCreated && entry.newLocation && (
                    <span className="ml-2">
                      ({entry.oldLocation || 'Non assigné'} → {entry.newLocation})
                    </span>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0 text-xs opacity-60">
                {entry.timestamp.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ScanHistoryPanel;
